import { Component, Input, OnInit } from '@angular/core';

import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from 'src/app/core/auth/auth.service';

@Component({
    selector: 'app-header-and-menu',
    templateUrl: './header-and-menu.component.html',
    styleUrls: ['./header-and-menu.component.scss'],
})
export class HeaderAndMenuComponent implements OnInit {
    @Input() sidenav!: MatSidenav;
    @Input() set openMenu(value: boolean) {
        this._openMenu = value;
    }

    _openMenu!: boolean;
    get getMatSidenav(): boolean {
        return this._openMenu;
    }
    name!: string;
    initialName!: string;
    constructor(private authService: AuthService) {}

    ngOnInit() {
        this.getName(localStorage.getItem('username') || '');
    }

    getName(name: string) {
        String(name);
        const firstName = name?.split('.')[0];
        const lastName = name?.split('.')[1];
        this.name = `${
            firstName.charAt(0).toUpperCase() + firstName.substr(1)
        } ${lastName.charAt(0).toUpperCase() + lastName.substr(1)}`;
        this.initialName =
            `${firstName.split('')[0].toUpperCase()}` +
            `${lastName.split('')[0].toUpperCase()}`;
    }

    logout() {
        this.authService.signOut();
    }
}
